import {Icon} from "../../../components/common/FontIcon";
import {useAppSelector} from "../../../redux/hooks";
import DemoMode from "../../../models/view/lessonPage/DemoMode";
import {lessonPlayerStore} from "../../../redux/lesson/LessonPlayerStore";

export interface IHandIcons {
  left: Icon;
  isLeftHandSoundOrHighlightEnabled?: boolean;
  right: Icon;
  isRightHandSoundOrHighlightEnabled?: boolean;
  highlights: string;
  dynamicLabel: string;
}

export interface IDemoModeSelectorIconLogic {
  handIcons: IHandIcons;
}

export function getDemoModeIcons(currentlySelectedDemoMode: DemoMode, isDemoLeftHandSoundEnabled: boolean, isDemoRightHandSoundEnabled: boolean): IHandIcons {
  // Everything on
  if (currentlySelectedDemoMode === "both hands" && isDemoLeftHandSoundEnabled && isDemoRightHandSoundEnabled) {
    return {
      left: 'icon-hand-left-solid-with-keys',
      isLeftHandSoundOrHighlightEnabled: true,
      right: 'icon-hand-right-solid-with-keys',
      isRightHandSoundOrHighlightEnabled: true,
      highlights: 'both hands',
      dynamicLabel: 'Both hand piano sound demos and keyboard highlights on',
    }
  }

  if (currentlySelectedDemoMode === "both hands" && !isDemoLeftHandSoundEnabled && isDemoRightHandSoundEnabled) {
    return {
      left: 'icon-keyboard-octave-top',
      isLeftHandSoundOrHighlightEnabled: true,
      right: 'icon-hand-right-solid-with-keys',
      isRightHandSoundOrHighlightEnabled: true,
      highlights: 'both hands',
      dynamicLabel: 'Right hand piano sound demo on and both keyboard highlights on',
    }
  }

  if (currentlySelectedDemoMode === "both hands" && isDemoLeftHandSoundEnabled && !isDemoRightHandSoundEnabled) {
    return {
      left: 'icon-hand-left-solid-with-keys',
      isLeftHandSoundOrHighlightEnabled: true,
      right: 'icon-keyboard-octave-top',
      isRightHandSoundOrHighlightEnabled: true,
      highlights: 'both hands',
      dynamicLabel: 'Left hand piano sound demo on and both keyboard highlights on',
    }
  }

  if (currentlySelectedDemoMode === "both hands" && !isDemoLeftHandSoundEnabled && !isDemoRightHandSoundEnabled) {
    return {
      left: 'icon-keyboard-octave-middle',
      isLeftHandSoundOrHighlightEnabled: true,
      right: 'icon-keyboard-octave-middle',
      isRightHandSoundOrHighlightEnabled: true,
      highlights: 'both hands',
      dynamicLabel: 'Piano sound demos off and both keyboard highlights on',
    }
  }

  if (currentlySelectedDemoMode === "off" && isDemoLeftHandSoundEnabled && isDemoRightHandSoundEnabled) {
    return {
      left: 'icon-hand-left-solid',
      isLeftHandSoundOrHighlightEnabled: true,
      right: 'icon-hand-right-solid',
      isRightHandSoundOrHighlightEnabled: true,
      highlights: 'off',
      dynamicLabel: 'Both piano sound demos on and both keyboard highlights off',
    }
  }

  if (currentlySelectedDemoMode === "off" && !isDemoLeftHandSoundEnabled && isDemoRightHandSoundEnabled) {
    return {
      left: 'icon-hand-left',
      isLeftHandSoundOrHighlightEnabled: false,
      right: 'icon-hand-right-solid',
      isRightHandSoundOrHighlightEnabled: true,
      highlights: 'off',
      dynamicLabel: 'Right hand piano sound demo on and both keyboard highlights off',
    }
  }

  if (currentlySelectedDemoMode === "off" && isDemoLeftHandSoundEnabled && !isDemoRightHandSoundEnabled) {
    return {
      left: 'icon-hand-left-solid',
      isLeftHandSoundOrHighlightEnabled: true,
      right: 'icon-hand-right',
      isRightHandSoundOrHighlightEnabled: false,
      highlights: 'off',
      dynamicLabel: 'Left hand piano sound demo on and both keyboard highlights off',
    }
  }

  if (currentlySelectedDemoMode === "left hand" && isDemoLeftHandSoundEnabled && isDemoRightHandSoundEnabled) {
    return {
      left: 'icon-hand-left-solid-with-keys',
      isLeftHandSoundOrHighlightEnabled: true,
      right: 'icon-hand-right-solid',
      isRightHandSoundOrHighlightEnabled: true,
      highlights: 'left hand',
      dynamicLabel: 'Both hand piano sound demos on and left keyboard highlights on',
    }
  }

  if (currentlySelectedDemoMode === "left hand" && !isDemoLeftHandSoundEnabled && isDemoRightHandSoundEnabled) {
    return {
      left: 'icon-keyboard-octave-top',
      isLeftHandSoundOrHighlightEnabled: true,
      right: 'icon-hand-right-solid',
      isRightHandSoundOrHighlightEnabled: true,
      highlights: 'left hand',
      dynamicLabel: 'Right hand piano sound demo on and left keyboard highlights on',
    }
  }

  if (currentlySelectedDemoMode === "left hand" && isDemoLeftHandSoundEnabled && !isDemoRightHandSoundEnabled) {
    return {
      left: 'icon-hand-left-solid-with-keys',
      isLeftHandSoundOrHighlightEnabled: true,
      right: 'icon-keyboard-octave-top',
      isRightHandSoundOrHighlightEnabled: false,
      highlights: 'left hand',
      dynamicLabel: 'Left hand piano sound demo on and left keyboard highlights on',
    }
  }

  if (currentlySelectedDemoMode === "left hand" && !isDemoLeftHandSoundEnabled && !isDemoRightHandSoundEnabled) {
    return {
      left: 'icon-keyboard-octave-middle',
      isLeftHandSoundOrHighlightEnabled: true,
      right: 'icon-keyboard-octave-middle',
      isRightHandSoundOrHighlightEnabled: false,
      highlights: 'left hand',
      dynamicLabel: 'Both piano sound demos off and left keyboard highlights on',
    }
  }

  if (currentlySelectedDemoMode === "right hand" && isDemoLeftHandSoundEnabled && isDemoRightHandSoundEnabled) {
    return {
      left: 'icon-hand-left-solid',
      isLeftHandSoundOrHighlightEnabled: true,
      right: 'icon-hand-right-solid-with-keys',
      isRightHandSoundOrHighlightEnabled: true,
      highlights: 'right hand',
      dynamicLabel: 'Both hand piano demo sounds on and right keyboard highlights on',
    }
  }

  if (currentlySelectedDemoMode === "right hand" && !isDemoLeftHandSoundEnabled && isDemoRightHandSoundEnabled) {
    return {
      left: 'icon-hand-left',
      isLeftHandSoundOrHighlightEnabled: false,
      right: 'icon-hand-right-solid-with-keys',
      isRightHandSoundOrHighlightEnabled: true,
      highlights: 'right hand',
      dynamicLabel: 'Right hand piano sound demo on and right keyboard highlights on',
    }
  }

  if (currentlySelectedDemoMode === "right hand" && isDemoLeftHandSoundEnabled && !isDemoRightHandSoundEnabled) {
    return {
      left: 'icon-hand-left-solid',
      isLeftHandSoundOrHighlightEnabled: true,
      right: 'icon-keyboard-octave-top',
      isRightHandSoundOrHighlightEnabled: true,
      highlights: 'right hand',
      dynamicLabel: 'Left hand piano sound demo on and right keyboard highlights on',
    }
  }

  if (currentlySelectedDemoMode === "right hand" && !isDemoLeftHandSoundEnabled && !isDemoRightHandSoundEnabled) {
    return {
      left: 'icon-keyboard-octave-middle',
      isLeftHandSoundOrHighlightEnabled: false,
      right: 'icon-keyboard-octave-middle',
      isRightHandSoundOrHighlightEnabled: true,
      highlights: 'right hand',
      dynamicLabel: 'Both hand piano sound demos off and right keyboard highlights on',
    }
  }

  // Everything off
  return {
    left: 'icon-keyboard-octave-middle',
    isLeftHandSoundOrHighlightEnabled: false,
    right: 'icon-keyboard-octave-middle',
    isRightHandSoundOrHighlightEnabled: false,
    highlights: 'off',
    dynamicLabel: 'Piano sound demos and keyboard highlights off',
  }
}

export const useDemoModeSelectorIconLogic = (): IDemoModeSelectorIconLogic => {
  const selectedDemoMode: DemoMode = useAppSelector(lessonPlayerStore.getDemoMode);
  const isDemoLeftHandSoundEnabled = useAppSelector(lessonPlayerStore.getIsDemoLeftHandSoundEnabled);
  const isDemoRightHandSoundEnabled = useAppSelector(lessonPlayerStore.getIsDemoRightHandSoundEnabled);

  return {
    handIcons: getDemoModeIcons(selectedDemoMode, isDemoLeftHandSoundEnabled, isDemoRightHandSoundEnabled),
  };
}
